import React from 'react'
import useMaybeTrailer from './useMaybeTrailer';

const widthMaybeTrailer = Component => props => {
    const [maybeVideo, youtubeId] = useMaybeTrailer(props.trailerAutoplay, props.trailerURL, props.fsk)
    
    return <Component 
        maybeVideo={maybeVideo}
        youtubeId={youtubeId}
        {...props} 
    />
}

export default widthMaybeTrailer